import { LuChevronDown } from "react-icons/lu";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  flex: 1;
  background-color: rgba(30, 30, 44, 1);
  color: white;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: flex-start;
  min-width: 200px;
  height: 100%;
  /* background-color: red; */
`;

export const TitleText = styled.div`
  color: #fff;
  font-family: "Noto Sans KR";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 44px; /* 220% */
  letter-spacing: -1.8px;
  margin-top: 7px;
`;

export const HRLight = styled.hr`
  width: 99.5%;
  margin-top: 27px;
  border: 1px dotted #d9d9d9;
  background-color: #d9d9d9;
  margin-bottom: 10px;
`;

export const Ul = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-top: 3px;
  /* min-width: 200px; */
`;

export const DisplayDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
`;

export const DisplayTextDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => props.$bottom ?? 0}px;
  /* background-color: red; */
  width: 100%;
`;

export const MenuLabel = styled.span`
  cursor: pointer;
`;

export const LucideIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 14px;
  color: ${(props) => (props.$active ? "#0079E0" : "#E8F2FF")};
`;

export const MenuItem = styled.li`
  display: block;
  font-family: "Noto Sans KR";
  min-height: 30px;
  height: auto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 5px;
  margin-top: ${(props) => props.$top ?? 10}px;
`;

export const MenuLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  /* gap: 8px; */
  height: 48px;
  width: 100%;
  /* background-color: red; */
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: ${(props) => (props.$active ? "#0079E0" : "#FFFFFF")};
`;

export const CircleIcon = styled.span`
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${(props) => (props.$active ? "#0079E0" : "#FFFFFF")};
  margin-right: 8px;
  margin-left: 40px;
`;

export const ArrowIcon = styled(LuChevronDown)`
  margin-left: ${(props) => props.left}px;
  color: #555555;
  transition: transform 0.15s ease;
  transform: rotate(${(props) => (props.$open ? "180deg" : "0deg")});
`;
